import { render, staticRenderFns } from "./marcasEditar.vue?vue&type=template&id=e60639bc&scoped=true&"
import script from "./marcasEditar.vue?vue&type=script&lang=js&"
export * from "./marcasEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60639bc",
  null
  
)

export default component.exports